import React from "react";
import MetaTags from "react-meta-tags";
import { Col, Row } from "antd";
import "./index.css";
import Contact from "./Contact";

function FrequentAsked() {
  return (
    <React.Fragment>
      {/* <Layout> */}
      <div>
        <MetaTags>
          <title> Contact Us | PMT</title>
        </MetaTags>

        <Row className="mb-10">
          <Col span={24}>
            <div className="contactUs-image">{/* PMTC */}</div>
          </Col>
          <Col span={24}>
            <div>
              <Contact />
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
}

export default FrequentAsked;
